var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "flexbox",
    { attrs: { align: "stretch" } },
    [
      _c(
        "flexbox-item",
        { staticStyle: { "margin-right": "50px" } },
        [
          _c("div", { staticClass: "area-title" }, [_vm._v("定位")]),
          _vm._v(" "),
          _c("el-autocomplete", {
            staticStyle: { width: "100%" },
            attrs: {
              "fetch-suggestions": _vm.querySearchAsync,
              placeholder: "请输入详细位置名称",
            },
            on: {
              blur: _vm.inputBlur,
              focus: _vm.inputFocus,
              select: _vm.handleSelect,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ item }) {
                  return [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.address + item.title)),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.searchInput,
              callback: function ($$v) {
                _vm.searchInput = $$v
              },
              expression: "searchInput",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "map", attrs: { id: "choicemap" } }),
          _vm._v(" "),
          _c("div", { staticClass: "area-title" }, [_vm._v("详细地址")]),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "" },
            model: {
              value: _vm.detail_address,
              callback: function ($$v) {
                _vm.detail_address = $$v
              },
              expression: "detail_address",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "flexbox-item",
        [
          _c("div", { staticClass: "area-title" }, [_vm._v("省/市/区")]),
          _vm._v(" "),
          _c("v-distpicker", {
            attrs: {
              province: _vm.addressSelect.province,
              city: _vm.addressSelect.city,
              area: _vm.addressSelect.area,
            },
            on: {
              province: _vm.selectProvince,
              city: _vm.selectCity,
              area: _vm.selectArea,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }